/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

/*

# Pages - Component for displaying a list of available pages for navigation

*/
define([
    "client/templates",
    "!!raw-loader!../mustache/template.mustache",
    "underscore"
  ], function(
    Templates,
    DEFAULT_TEMPLATE,
    _
  ) {

  var PagesView = Templates.View.extend({ });
  var PagesTemplate = Templates.add({
    name: "editor_pages",
    view: PagesView,
    attributes: {
      maxPageCount: {
        title: "editor_pages_max_page_count",
        type: "int",
        defaultValue: 10
      }
    },
    content: {
      type: "template"
    },
    default_template: DEFAULT_TEMPLATE && DEFAULT_TEMPLATE.default,
    designer_menu: [{
      name: "editor_pages",
      icon: "../img/imgpages.png",
      description: "editor_pages_description",
      group: {
        name: "editor_pager_title",
      }
    }]
  });

  // child views are created immediately
  var originalCreateView = PagesTemplate.prototype.createView;
  PagesTemplate.prototype.createView = function () {
    var view = originalCreateView.apply(this, arguments);
    _.each(view.options.node.children, function (childNode) {
        this.createSubView(childNode, view.options, view.model);
    }, this);
    return view;
  }

  // the pages model is created by the template and stored in this.models for later cleanup
  PagesTemplate.prototype.model = function (options) {
    var templateOptions = this.schema.parseAttributes(this.attributeModel.getCamelCase())
    var model = options.model.getPagesModel({
      maxPageCount: templateOptions.maxPageCount
    })
    this.models = this.models || [];
    this.models.push(model);
    return model;
  };

  // clean up all the created models
  var originalRemove = PagesTemplate.prototype.remove;
  PagesTemplate.prototype.remove = function (options) {
    _.each(this.models, function (model) {
      model.dispose();
    });
    this.models = [];
    return originalRemove.apply(this, arguments);
  }

  return PagesTemplate;
});
